import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight, FileText } from "lucide-react";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardRowButton } from "web_myplann/Dashboard/Components/DashboardRowButton";
import type { TaskListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import { IconBox } from "web_myplann/Shared/Components/IconBox";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";
import { CIRCLE_SIGN } from "web_myplann/Utils/constants";

type Props = {
	data: TaskListItemResponseDTO;
	showDivider: boolean;
};

export const DashboardTaskRow: FC<Props> = ({ data, showDivider }) => {
	const theme = useTheme();
	const { t } = useResource();
	const navigate = useNavigate();

	const taskLabel = t(Resources.Activity.List.Task);
	const title = data.title
		? `${taskLabel} ${CIRCLE_SIGN} ${data.title}`
		: taskLabel;
	const dateLabel = data.date
		? `${dateFormatter(data.date)} ${data.time?.slice(0, -3) ?? ""}`.trim()
		: "";

	return (
		<DashboardRowButton
			showDivider={showDivider}
			onClick={() => {
				if (data.id != null) {
					navigate(AppRouting.MyPlann.TaskDetail.path(String(data.id)));
				}
			}}
		>
			<IconBox bg={theme.palette.blue[100]}>
				<FileText size={theme.iconSize.md} color={theme.palette.blue[600]} />
			</IconBox>
			<Stack flex={1} minWidth={0}>
				{dateLabel && (
					<Typography variant="caption" color={theme.palette.grey[500]}>
						{dateLabel}
					</Typography>
				)}
				<Typography
					variant="bodyMedium"
					color="text.primary"
					overflow="hidden"
					whiteSpace="nowrap"
					textOverflow="ellipsis"
				>
					{title}
				</Typography>
			</Stack>
			<ChevronRight size={theme.iconSize.sm} color={theme.palette.grey[400]} />
		</DashboardRowButton>
	);
};
